enum PlateSize {
  PlateSize96,
  PlateSize96D,
  PlateSize48,
  PlateSize384
}

export default PlateSize;
